import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { tenantSettingsAPI } from '@/providers/apis/tenant-settings/tenant-settings';
import { sessionService } from '@/providers/services/auth/session';
import { ROSTER_TOPIC_LIST } from '@/utils/constants';
import { Vue, Component } from 'vue-property-decorator';

@Component({
    name: 'tenant-data',
    components: {
        'gm-icon': GoogleMaterialIcon,
        'users-list': () => import('./user-details/user-details.vue'),
        'courses-list': () => import('./courses-details/courses-details.vue'),
        'class-list': () => import('./class-details/class-details.vue'),
        'orgs-list': () => import('./org-details/org-details.vue'),
        'academic-list': () => import('./academic/academic.vue'),
        'popup-layout': () => import('@/components/cards/slide-popup-layout/slide-popup-layout.vue'),
        'roster-upload': () => import('./roster-upload/roster-upload.vue'),
        'enrollment-list': () => import('./enrollment-list/enrollment-list.vue'),
    },
})

export default class TenantData extends Vue {

    // -------------------------------------------------------------------------
    // Properties

    private topicList: any = ROSTER_TOPIC_LIST;

    private activeComponent: string = 'users-list';

    private isShowPullup: boolean = false;

    private eventBind: any = {};

    private propBind: any = {};

    private get session() {
        return sessionService.getSession();
    }

    private tenantDetail: any = {};

    private dataBind: any = {};

    // ---------------------------------------------------------------
    // Hooks

    private created() {
        const orgId: any = this.$route!.query!.sourceId;
        this.dataBind = {
            sourceId: orgId,
        };
        this.getTenantDetails();
    }


    // ------------------------------------------------------------------------
    // Actions
    private onGoBack() {
        this.$router.push('/setup/roster/tenant-details');
    }

    private onChangeList(name: string) {
        this.activeComponent = name;
    }

    private onSelectRow(content: any) {
        this.isShowPullup = true;
        this.propBind = content;
    }

    // ------------------------------------------------------------------------
    // Methods

    private getTenantDetails() {
        const tenantId: any = this.session!.tenant!.tenant_id;
        tenantSettingsAPI.fetchTenantById(tenantId).then((tenantDetail) => {
            this.tenantDetail = tenantDetail;
        });
    }




}
